import { SUBSCRIPTION_URL, USER_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const UserService = {
  getAll: (params: any) => requests.get(`${USER_URL}`, params),
  create: (params: any) => requests.post(`${USER_URL}`, params, true),
  getSingle: (id: number) => requests.get(`${USER_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.put(`${USER_URL}/${id}`, params,true),
  changePassword: (params: any, id: number) =>
    requests.put(`${USER_URL}/change-password/${id}`, params),
  delete: (id: number) => requests.delete(`${USER_URL}/${id}`),
  deleteDocument: (id: number) => requests.delete(`${USER_URL}/document/${id}`),
};

export const SubscriptionService = {
  getAll: (userId: number) =>
    requests.get(`${SUBSCRIPTION_URL}/user-subscriptions/current/${userId}`),
  assignPackage: (params: { user: number; package: number; duration: string }) =>
    requests.post(`${SUBSCRIPTION_URL}/user-subscriptions/assign-package`, params),
  getPackages: (params:any) => requests.get(`${SUBSCRIPTION_URL}/packages`,params),
  getSubscriptionHistory: (userId: number) =>
    requests.get(`${SUBSCRIPTION_URL}/user-subscriptions/subscription-history/${userId}`), // New method
};